export default __webpack_public_path__ + "static/media/separator1-mobil1.8cf3cc9c.png";